import { heroStats, readingPromises } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20swirling%20flame%20in%20deep%20orange%20and%20crimson%20tones%20over%20dark%20warm%20brown%20background%2C%20dramatic%20glowing%20light%2C%20misty%20smoke%20texture%2C%20cinematic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=reborn-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/90" />
        <div className="animate-glow absolute -left-24 top-1/3 h-72 w-72 rounded-full bg-primary-500/30 blur-3xl" />
      </div>

      <div className="relative mx-auto w-full max-w-6xl px-4 pb-16 pt-32 md:px-8 md:pb-24 md:pt-40">
        <div className="animate-fade-up mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-300/40 bg-primary-500/15 px-4 py-1.5 text-xs font-medium tracking-wide text-primary-100">
            <i className="ri-fire-line" />
            剧情解析 · 角色介绍 · 结局讨论
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black leading-snug text-background-50 md:text-5xl md:leading-tight">
            我的家庭教师：从废柴纲到彭格列十代目的成长全解析
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-background-100/85 md:text-base md:leading-8">
            这里汇集《我的家庭教师》的剧情深度解析，包括里包恩、纲吉等主要角色的背景与成长线，并针对结局展开讨论。无论你是老粉还是新观众，都能从中获得对故事脉络的清晰理解。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#characters"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              从角色图鉴开始
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#arcs"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/35 bg-white/10 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-white/20 sm:w-auto"
            >
              查看篇章脉络
            </a>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-3 md:mt-20 md:grid-cols-4 md:gap-5">
          {heroStats.map((stat) => (
            <div
              key={stat.id}
              className="rounded-lg border border-background-100/15 bg-white/10 px-4 py-4 text-center backdrop-blur-sm md:px-5 md:py-5"
            >
              <div className="font-heading text-xl font-bold text-background-50 md:text-2xl">{stat.value}</div>
              <div className="mt-1 text-xs text-background-100/75 md:text-sm">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-10 grid gap-4 md:mt-14 md:grid-cols-3 md:gap-5">
          {readingPromises.map((item) => (
            <div
              key={item.id}
              className="rounded-lg border border-background-100/15 bg-foreground-950/40 p-5 backdrop-blur-sm"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500/20 text-primary-200">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-background-50">{item.title}</h3>
              <p className="mt-2 text-sm leading-6 text-background-100/75">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}